module.exports = __webpack_public_path__ + "static/media/visal-sm-logo.f7c857ed.png";